module.exports = __webpack_public_path__ + "images/c0467b2c3d39364c0a239601dfda3599.EOS_Logo_Colored.svg";